<template>
<div class="user-invite-form">
    <div class="field is-horizontal" @input="clearValidation">
        <div class="field-body">
            <div class="field has-addons">
                <p class="control has-icons-left has-icons-right user-email-input">
                    <input
                        name="email"
                        class="input"
                        type="email"
                        autocomplete="off"
                        :placeholder="trans.email_input_placeholder"
                        v-model="form.email"
                        @keyup.enter="validate"
                    >
                    <span class="icon is-medium is-left">
                        <i class="fas fa-envelope"></i>
                    </span>
                </p>
                <p class="control">
                    <button
                        class="button is-info"
                        :class="{ 'is-loading': isLoading }"
                        :disabled="isLoading"
                        @click="validate"
                    >
                        {{ trans.invite_button }}
                    </button>
                </p>
            </div>
        </div>
    </div>
    <p v-show="errors.email" class="help is-danger">
        {{ errors.email }}
    </p>
</div>
</template>

<script>
    import {mapActions} from "vuex";
    import {axiosForm} from "../../../mixins/axiosFormMixin";

    export default {
        name: "UserInviteForm",
        mixins: [
            axiosForm,
        ],
        data() {
            return {
                form: {
                    email: null,
                },
            };
        },
        methods: {
            ...mapActions('userManagement', ['addAttachingUser']),

            /**
             * Валидация формы
             */
            validate(e) {
                this.submit(e, this.action, 'options' );
            },

            /**
             * Обработчик ответа сервера
             */
            postResultHandler(response) {
                if (response.data.validated) {
                    this.addUser();
                    this.clearForm();
                }
            },

            /**
             * Добавление пользователя в список прикрепляемых
             */
            addUser() {
                this.addAttachingUser({
                    id: this.form.email,
                    name: this.form.email,
                    email: this.form.email,
                });
            },

            /**
             * Очистка формы
             */
            clearForm() {
                this.form.email = null;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .user-invite-form {
        .field.has-addons {
            flex: 0 48%;

            .user-email-input {
                flex: 0 100%;
            }
        }
    }
</style>
